import register from '../register';

register( 'about-page', () => {

  let btn = document.querySelector('.expand-more');
  let teamContainer = document.querySelector('.our-team');
  let parent = btn.closest('.shadow-card');

  btn.addEventListener( 'click', () => {
    teamContainer.classList.toggle('is-open');
    if ( teamContainer.classList.contains('is-open') ) {
      btn.innerText = 'Less';
      return;
    }
    btn.innerText = 'More';
  });

  btn.addEventListener( 'mouseenter', () => {
    parent.classList.add('is-hovered');
  });

  btn.addEventListener( 'mouseleave', () => {
    parent.classList.remove('is-hovered');
  });

});

export default undefined;
